import { ImageCropperMaxScale, ImageCropperMinScale } from "../constants";

export const calculateCropFromTranslationWorklet = ({
	targetX,
	targetY,
	crop,
	inside,
}: {
	targetX: number;
	targetY: number;
	crop: { x: number; y: number; scale: number };
	inside: { width: number; height: number };
}): {
	x: number;
	y: number;
	scale: number;
} => {
	"worklet";

	const insideSize = Math.min(inside.width, inside.height);
	const xBound =
		(inside.width - inside.width / crop.scale) / 2 +
		(inside.width - insideSize) / 2 / crop.scale;
	const yBound =
		(inside.height - inside.height / crop.scale) / 2 +
		(inside.height - insideSize) / 2 / crop.scale;
	return {
		x: Math.max(-xBound, Math.min(targetX, xBound)),
		y: Math.max(-yBound, Math.min(targetY, yBound)),
		scale: crop.scale,
	};
};

export const calculateCropFromScaleWorklet = ({
	targetScale,
	crop,
	inside,
}: {
	targetScale: number;
	crop: { x: number; y: number; scale: number };
	inside: { width: number; height: number };
}): {
	x: number;
	y: number;
	scale: number;
} => {
	"worklet";

	const insideSize = Math.min(inside.width, inside.height);
	const newScale = Math.min(Math.max(ImageCropperMinScale, targetScale), ImageCropperMaxScale);
	const xBound =
		(inside.width - inside.width / newScale) / 2 + (inside.width - insideSize) / 2 / newScale;
	const yBound =
		(inside.height - inside.height / newScale) / 2 +
		(inside.height - insideSize) / 2 / newScale;
	return {
		x: Math.max(-xBound, Math.min(crop.x, xBound)),
		y: Math.max(-yBound, Math.min(crop.y, yBound)),
		scale: newScale,
	};
};
